import { createSelector } from '@reduxjs/toolkit';
import {
  ArticleData,
  ArticlesSection,
  HomepageContent,
  ResourcesSection,
  SectionId,
} from '@wix/wix-help-widget-common/homepage';

import { TRootState } from '../reducers';
import { IHomepageSectionState } from '../reducers/types';

type HomepageContentState = IHomepageSectionState<HomepageContent>;
type RecommendedArticleState = IHomepageSectionState<{
  articles: ArticleData[];
  modelId?: string;
}>;

export const selectHomepageContent = createSelector(
  (state: TRootState) => state.homepage.content,
  ({ data, loading, error }): HomepageContentState => ({
    data,
    loading,
    error,
  }),
);

export const selectRecommendedArticles = createSelector(
  (state: TRootState) => state.homepage.articles,
  ({ data, loading, error }): RecommendedArticleState => ({
    data,
    loading,
    error,
  }),
);

export const selectScrolledToTop = (state: TRootState): boolean => {
  return state.homepage.scrolledToTop;
};

export const selectReportABugFlowStarted = (state: TRootState): boolean => {
  return state.homepage.reportABugFlowStarted;
};

export const selectRecommendedArticlesSection = createSelector(
  (state: TRootState) => state.homepage.content.data,
  (content): ArticlesSection | undefined => {
    const articlesSection = content?.sections.find((section) => section.sectionId === SectionId.Articles);

    return articlesSection as ArticlesSection;
  },
);

export const selectResourcesSection = createSelector(
  (state: TRootState) => state.homepage.content.data,
  (content): ResourcesSection | undefined => {
    const resourcesSection = content?.sections.find((section) => section.sectionId === SectionId.Resources);

    return resourcesSection as ResourcesSection;
  },
);
